import { genBlock } from "@/utils/bem";
import {
  Box,
  Center,
  ChakraProps,
  Flex,
  Grid,
  GridItem,
  Image,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Text,
  UseModalProps,
  chakra,
  Tooltip,
} from "@chakra-ui/react";
import { MouseEventHandler, ReactNode, useCallback, useEffect, useMemo } from "react";
import BindPhone from "./components/BindPhone";
import QRCodeLogin from "./components/QRCodeLogin";
import PhoneLogin from "./components/AccountLogin";
import { DialogType, loginStore } from "./store";
import Forgotten from "./components/ForgottenPassword";
import { ChevronLeftIcon } from "@chakra-ui/icons";
import { observer } from "mobx-react-lite";
import { langStore, translate } from "@noli/business";
import wechatOAuthIcon from "@/assets/images/login/wechat_gray.png";
import phoneOAuthIcon from "@/assets/images/login/phone_gray.png";
import { useResponsive } from "@/utils/style";
import Icon from "@/components/Icon";
import { ReactComponent as LogoSvg } from "@/assets/icons/new_logo.svg";
import { useHistory } from "react-router";
import { Login_Words } from "@/utils/lang";
import LinkBtn from "./components/LinkBtn";
import MyGadget from "@/components/bussiness/MyGadget";
import { ReactComponent as ServerIcon } from "@/assets/icons/header/server.svg";
import { ReactComponent as OpenApiIcon } from "@/assets/icons/header/open_api_icon.svg";
import StationMessage from "@/components/bussiness/StationMessage";
import { themeStore } from "@/stores/theme";
import record from "@/assets/images/login/record.png";
import { QrCodeIcon } from "@/components/Icons";
import config from "@/config";

export const loginBlock = genBlock("login");
const BILIBILI_LINK =
  "https://www.bilibili.com/video/BV1Pt4y1K79B/?spm_id_from=333.999.0.0&vd_source=d41d6a149c2ee2abbd464a0053ac1597";

interface LoginModalProps {
  isOpen: boolean;
  onClose: UseModalProps["onClose"];
  modalType: DialogType;
}

export const OAuthBlock = observer(() => {
  const lang = langStore.tgt;
  // 临时给大家微信登录，后续还是要换回来
  const mode = "zh";
  const handleSelect = useCallback<MouseEventHandler<HTMLDivElement>>((e) => {
    const tgt = e.currentTarget as HTMLDivElement;
    const channel = tgt.dataset.channel as unknown as string;
    switch (channel) {
      case "weChat":
        loginStore.setDialogType("phoneCode");
        break;
      case "google":
        break;
      default:
        loginStore.setDialogType("weChat");
        break;
    }
  }, []);

  const zhOAuthBlock = useMemo(() => {
    switch (loginStore.dialogType) {
      case "weChat":
        return (
          <Flex
            data-channel="weChat"
            onClick={handleSelect}
            cursor="pointer"
            userSelect="none"
            justify="center"
            align="center"
          >
            <Image w="36px" src={phoneOAuthIcon}></Image>
            <Text ml="0.5em" color="#86909C" fontSize={"14px"}>
              {translate(Login_Words.codeOrAccountAuth, lang)}
            </Text>
          </Flex>
        );
      case "forgot":
      case "phoneBind":
        return null;
      default:
        return (
          <Flex
            data-channel={loginStore.dialogType}
            onClick={handleSelect}
            cursor="pointer"
            userSelect="none"
            justify="center"
            align="center"
          >
            <Image w="36px" src={wechatOAuthIcon}></Image>
            <Text ml="0.5em" color="#86909C" fontSize={"14px"}>
              {translate(Login_Words.wechatAuth, lang)}
            </Text>
          </Flex>
        );
    }
  }, [loginStore.dialogType, handleSelect]);

  const enOAuthBlock = useMemo(() => {
    switch (loginStore.dialogType) {
      case "forgot":
        return null;
      default:
        // 谷歌登录接入成功后打开
        return null;
      // return (
      //   <>
      //     <Text
      //       color="#86909C"
      //       pos="relative"
      //       fontSize="12px"
      //       my="16px"
      //       _before={{
      //         content: "''",
      //         width: "150%",
      //         h: "1px",
      //         bgColor: "#E5E6EB",
      //         pos: "absolute",
      //         top: "50%",
      //         right: "120%",
      //       }}
      //       _after={{
      //         content: "''",
      //         width: "150%",
      //         h: "1px",
      //         bgColor: "#E5E6EB",
      //         pos: "absolute",
      //         top: "50%",
      //         left: "120%",
      //       }}>
      //       Another way
      //     </Text>
      //     <Flex
      //       data-channel="google"
      //       onClick={handleSelect}
      //       cursor="pointer"
      //       userSelect="none"
      //       justify="center"
      //       align="center">
      //       <Image w="36px" src={googleOAuthIcon}></Image>
      //       <Text ml="0.5em" color="#86909C">
      //         {translate(Login_Words.googleAuth, lang)}
      //       </Text>
      //     </Flex>
      //   </>
      // );
    }
  }, []);

  return (
    <Flex justify="center">
      {mode === "zh" ? (
        <Flex flexDir="column" align="center">
          {loginStore.dialogType !== "forgot" && loginStore.dialogType !== "phoneBind" && (
            <Text
              color="#86909C"
              pos="relative"
              fontSize="12px"
              my="16px"
              minW="70px"
              textAlign="center"
              _before={{
                content: "''",
                width: "150%",
                h: "1px",
                bgColor: "#E5E6EB",
                pos: "absolute",
                top: "50%",
                right: "120%",
              }}
              _after={{
                content: "''",
                width: "150%",
                h: "1px",
                bgColor: "#E5E6EB",
                pos: "absolute",
                top: "50%",
                left: "120%",
              }}
            >
              {translate(Login_Words.moreAuth, lang)}
            </Text>
          )}
          {zhOAuthBlock}
          {lang === "zh" && (
            <Text color="#86909C" pos="relative" fontSize="12px" my="16px" textAlign="center">
              <span>No China phone number？</span>
              <span
                style={{ color: "#4E5969", cursor: "pointer" }}
                onClick={() => {
                  langStore.switchTo("en");
                  loginStore.setDialogType("account");
                }}
              >
                Click here
              </span>
            </Text>
          )}
        </Flex>
      ) : (
        <Flex flexDir="column" align="center">
          {enOAuthBlock}
        </Flex>
      )}
    </Flex>
  );
});

export const LoginModal = observer(({ isOpen, onClose, modalType }: LoginModalProps) => {
  const lang = langStore.tgt;
  const calcPx = useResponsive();
  const modalBody = useMemo(() => {
    if (modalType === "phoneBind") {
      return <BindPhone />;
    } else if (modalType === "weChat") {
      return <QRCodeLogin />;
    } else if (modalType === "forgot") {
      return <Forgotten />;
    } else {
      return <PhoneLogin />;
    }
  }, [modalType]);

  const modalFooter = useMemo(() => {
    switch (modalType) {
      case "phoneBind":
        return (
          <Text w="100%" fontSize="12px" align="center">
            {translate(Login_Words.bindPhoneFooter, lang)}
          </Text>
        );
      case "forgot":
        return (
          <Text w="100%" fontSize="12px" align="center">
            {translate(Login_Words.forgotFooter, lang)}
          </Text>
        );
      default:
        return (
          <Text fontSize="12px" color="#86909C" w="100%" align="center">
            <chakra.span>{translate(Login_Words.agreePolicy, lang)}</chakra.span>
            <Link
              color="#4E5969"
              target="_blank"
              href={`${config.buildCdnBaseUrl}assets/doc/creator_agreement.pdf`}
            >
              {translate(Login_Words.servicePolicy, lang)}
            </Link>
            <chakra.span>{translate(Login_Words.and, lang)}</chakra.span>
            <Link
              color="#4E5969"
              target="_blank"
              href={`${config.buildCdnBaseUrl}assets/doc/creator_privacy_policy.pdf`}
            >
              {translate(Login_Words.privacyPolicy, lang)}
            </Link>
          </Text>
        );
    }
  }, [modalType, lang]);

  const contentTitle = useMemo(() => {
    switch (modalType) {
      case "forgot":
        return translate(Login_Words.changPassword, lang);
      case "phoneBind":
        return translate(Login_Words.bindPhone, lang);
      default:
        return translate(Login_Words.modalTitle, lang);
    }
  }, [modalType, lang]);

  const handleForgetBack = () => {
    switch (modalType) {
      case "phoneBind":
        loginStore.setDialogType("weChat");
        break;
      case "forgot":
        loginStore.setDialogType("account");
        break;
      default:
        break;
    }
  };

  return (
    <Modal scrollBehavior="inside" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        className={loginBlock({ e: "qrModal" })}
        marginTop={calcPx(150)}
        paddingLeft={"20px"}
        paddingRight={"20px"}
        w="448px"
        minH="556px"
        borderRadius={12}
      >
        <ModalHeader pos="relative">
          {modalType === "forgot" || modalType === "phoneBind" ? (
            <Box
              display="inline-block"
              pos="absolute"
              top="9px"
              left="5px"
              userSelect="none"
              cursor="pointer"
              onClick={handleForgetBack}
            >
              <ChevronLeftIcon boxSize="1.2em" color={"#C9CDD4"} />
              <Text display="inline-block" fontSize={"14px"} fontWeight={400} color={"#C9CDD4"}>
                {translate(Login_Words.back, lang)}
              </Text>
            </Box>
          ) : null}
        </ModalHeader>
        <ModalCloseButton
          _focusVisible={{
            boxShadow: "none",
          }}
          fontSize={"16px"}
          color={"#C9CDD4"}
        />
        <ModalBody>
          <Flex flexDir="column" align="center" userSelect={"none"} w="100%" px={4}>
            <Text
              textAlign="center"
              fontSize="22px"
              lineHeight="28px"
              fontWeight="600"
              fontFamily="PingFang SC"
              marginBottom="28px"
            >
              {contentTitle}
            </Text>
            {modalBody}
            <OAuthBlock />
          </Flex>
        </ModalBody>
        <ModalFooter>{modalFooter}</ModalFooter>
      </ModalContent>
    </Modal>
  );
});

interface HWLProps {
  css?: ChakraProps["css"];
  leftLinks?: {
    key: string;
    to: string;
    text: string;
  }[];
  leftPanels?: ReactNode[];
  rightPanels?: ReactNode[];
  renderBanner?: boolean;
  renderBell?: boolean;
  renderBusinessLink?: boolean;
}

export const HeaderWithLogin = observer(
  ({
    leftLinks,
    leftPanels = [],
    rightPanels = [],
    css = {},
    renderBanner = false,
    renderBell = false,
    renderBusinessLink = false,
  }: HWLProps) => {
    console.log("renderBanner", renderBanner);
    const lang = langStore.tgt;
    const logout = translate(Login_Words.logout, lang);
    const history = useHistory();
    const { panelBg } = themeStore.styles;
    const size = "64px";
    const isLinkActive = useCallback(
      (linkKey: string) => {
        const reg = new RegExp(linkKey);
        if (reg.test(history.location.pathname)) {
          console.log(linkKey, history.location.pathname, reg.test(history.location.pathname));
          return true;
        }
        return false;
      },
      [history.location.pathname],
    );
    // const handleNav = useCallback<React.MouseEventHandler<HTMLParagraphElement>>(
    //   (e) => {
    //     const navPath = e.currentTarget.dataset.nav;
    //     switch (navPath) {
    //       case "/creator":
    //         if (!loginStore.isLogin) {
    //           loginStore.openLoginDialog({}, () => {
    //             history.push("/creator");
    //           });
    //         } else if (!loginStore.hasAIGCPermission) {
    //           history.push("/noPermission");
    //         } else {
    //           history.push(navPath);
    //         }
    //         break;
    //       case "/gallery":
    //         history.push(navPath);
    //         break;
    //       default:
    //         break;
    //     }
    //   },
    //   [history],
    // );

    const linkBtnClicked = useCallback(
      (linkPath: string) => {
        // const navPath = link;
        switch (linkPath) {
          case "/creator":
            if (!loginStore.isLogin) {
              loginStore.openLoginDialog({}, () => {
                history.push("/creator");
              });
            } else if (!loginStore.hasAIGCPermission) {
              history.push("/noPermission");
            } else {
              history.push(linkPath);
            }
            break;
          case "/gallery":
          case "/my_space":
            history.push(linkPath);
            break;
          default:
            break;
        }
      },
      [history],
    );

    const closeHandler = useCallback(() => {
      loginStore.closeDialog();
      if (loginStore.dialogType === "phoneBind") {
        loginStore.setDialogType("weChat");
      }
    }, []);

    const defultLeftPanels = useMemo(() => {
      const links = leftLinks ?? [
        {
          key: "creator",
          to: "/creator",
          text: "Creator 工作站",
        },
        {
          key: "gallery",
          to: "/gallery",
          text: "Gallery 艺术展",
        },
      ];
      return links.map((link) => {
        if (link.key === "creator") {
          return (
            <LinkBtn
              key={link.key}
              content={link.text}
              handleClick={() => linkBtnClicked(link.to)}
              isActive={isLinkActive(link.to)}
            />
          );
        } else {
          return (
            <a
              style={{
                marginLeft: 20,
                height: "100%",
                display: "flex",
                alignItems: "center",
              }}
              href={link.to}
              key={link.key}
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              <LinkBtn
                key={link.key}
                content={link.text}
                handleClick={() => linkBtnClicked(link.to)}
                isActive={isLinkActive(link.to)}
              />
            </a>
          );
        }
      });
    }, [linkBtnClicked]);

    useEffect(() => {
      if (!loginStore.isLogin && ["/", "/login"].includes(history.location.pathname)) {
        history.replace("/");
      }
    }, []);

    const handleBackToRoot = () => {
      if (/noPermission/.test(history.location.pathname) && loginStore.isLogin) return;
      history.push("/");
    };

    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          position: "fixed",
          zIndex: 3,
        }}
      >
        {/* {renderBanner && (
          <img
            src={TopBannerImg}
            style={{ width: "100%", cursor: "pointer" }}
            onClick={() => window.open(BILIBILI_LINK, "_bank")}
          />
        )} */}

        <Flex
          w="100%"
          h={size}
          color="#ffffff"
          bg={"#1f222d"}
          flexShrink={0}
          boxShadow="0px 4px 8px rgba(0, 0, 0, 0.15);"
          // position="fixed"
          zIndex={3}
          css={css}
        >
          <Flex
            w="224px"
            h={size}
            shrink={0}
            grow={0}
            paddingLeft={8}
            alignItems="center"
            onClick={handleBackToRoot}
            cursor="pointer"
          >
            <Icon svg={LogoSvg} squared={false} />
          </Flex>
          {/* {defultLeftPanels} */}
          {leftPanels}
          {["/gallery", "/en/gallery"].includes(location.pathname) && loginStore.headerSearchNode}
          {(!["/gallery", "/en/gallery"].includes(location.pathname) ||
            !loginStore.headerSearchNode) && <Spacer />}
          <Flex h={size} flexShrink={0} paddingRight={8} alignItems="center" flexDir="row-reverse">
            {loginStore.hasUserInfo ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                <LinkBtn
                  content="Space 我的空间"
                  handleClick={() => history.push("/my_space")}
                  isActive={isLinkActive("my_space")}
                />
                {renderBell && <StationMessage />}
                <MyGadget triggerStyle={{ marginLeft: "18px" }} />
              </div>
            ) : null}
            {/* ) : (
              <LinkBtn
                content={"注册 / 登陆"}
                handleClick={() => {
                  if (!loginStore.hasUserInfo) {
                    loginStore.openLoginDialog({});
                  }
                }}
              />
            )} */}
            {renderBusinessLink && (
              <Link
                href="/business"
                target="_blank"
                display="flex"
                alignItems="center"
                justifyContent="center"
                mr="23px"
                bg="linear-gradient(270deg, #F0BF68 26.79%, #F9E5AE 132.14%)"
                w="142px"
                h="28px"
                fontSize="16px"
                rounded="8px"
                bgClip="text"
                fontWeight="600"
                pos="relative"
                _after={{
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: 0,
                  w: "100%",
                  h: "100%",
                  zIndex: -2,
                  bg: "linear-gradient(270deg, #F0BF68 26.79%, #F9E5AE 132.14%)",
                  rounded: "8px",
                }}
                _before={{
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: 0,
                  w: "100%",
                  h: "100%",
                  zIndex: -1,
                  bg: panelBg,
                  border: "1px solid",
                  bgClip: "content-box",
                  rounded: "8px",
                }}
              >
                <ServerIcon style={{ marginRight: "6px" }} /> 企业解决方案
              </Link>
            )}
            {/* <Link
              href="https://open.creator.nolibox.com"
              target="_blank"
              display="flex"
              alignItems="center"
              justifyContent="center"
              color={panelBg}
              mr="16px"
              bg="linear-gradient(270deg, #F0BF68 26.79%, #F9E5AE 132.14%)"
              w="142px"
              h="28px"
              fontSize="16px"
              rounded="8px"
              fontWeight="600"
              style={{
                textDecoration: "none",
              }}>
              <OpenApiIcon />
              API 开放平台
            </Link> */}

            {rightPanels}
          </Flex>

          <LoginModal
            modalType={loginStore.dialogType}
            isOpen={loginStore.loginState.visible || loginStore.loginState.bindPhoneVisible}
            onClose={closeHandler}
          />
        </Flex>
      </div>
    );
  },
);

const infos = [
  {
    title: "用户中心",
    links: [
      // {
      //   key: "产品帮助文档",
      //   link: "https://f8y4v1rln8.feishu.cn/wiki/wikcna7VCVJOxmTeVmQY5Jj0nSf",
      // },
      // {
      //   key: "产品使用方法",
      //   link: "https://f8y4v1rln8.feishu.cn/wiki/wikcnlHLIsZUOnYsCQc3YQUMA4e",
      // },
      // {
      //   key: "关键词（Prompt）知识",
      //   link: "https://f8y4v1rln8.feishu.cn/wiki/wikcn5OQ4fzUol32sJ0jV0zjSxd",
      // },
      {
        key: "版权声明",
        link: "https://f8y4v1rln8.feishu.cn/wiki/wikcnC8le94X75xzdXDIWyBpIxc",
      },
    ],
  },
  {
    title: "友情链接",
    links: [
      {
        key: "百度文心",
        link: "https://wenxin.baidu.com/",
      },
    ],
  },
  {
    title: "更多产品",
    links: [
      {
        key: "图宇宙",
        link: "https://www.nolibox.com/introduction",
      },
      {
        key: "图宇宙企业版",
        link: "https://qiye.nolibox.com",
      },
    ],
  },
  {
    title: "商务合作",
    links: [
      {
        key: "邮箱：official@nolibox.com",
        link: "",
      },
      {
        key: "商务/销售微信: 微信扫码",
        link: "",
        qr_link: "http://nolipix-js.nolibox.com/assets/creator/business/contact_qrcode_wechat.png",
      },
      // {
      //   key: "商务/销售电话: 166 2203 4570",
      // },
      // {
      //   key: "生态合作微信：noliboxljs",
      //   link: "",
      //   qr_link: "http://nolipix-js.nolibox.com/assets/creator/business/qr_channel.png",
      // },
      // {
      //   key: "生态合作电话：180 1016 7386",
      //   link: "",
      // },
      {
        key: "公司地址: 北京市海淀区五道口东升大厦A座",
        link: "",
      },
    ],
  },
  {
    title: "客服和维保响应",
    links: [
      {
        key: "邮箱：support@nolibox.com",
        link: "",
      },
      {
        key: "维保响应: 微信扫码",
        link: "",
        qr_link: "http://nolipix-js.nolibox.com/assets/creator/business/contact_qrcode_wechat.png",
      },
      {
        key: "客服微信：微信扫码",
        qr_link: "http://nolipix-js.nolibox.com/assets/creator/business/contact_qrcode_wechat.png",
      },
    ],
  },
];
const copyright = (
  <Text>
    <Text>Copyright © 2021-现在 北京计算美学科技有限公司</Text>
    <Text>网信算备 110108210709901230015 号</Text>
    <Text>京ICP备2021032906号</Text>
    <Link
      href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802041582"
      target="_blank"
      display="inline-flex"
      alignItems="center"
    >
      <Image src={record} display="inline-block" h="14px" />
      <chakra.span>京公网安备 11010802041582号</chakra.span>
    </Link>
  </Text>
);
const noLinkStyle: ChakraProps = {
  pointerEvents: "none",
  userSelect: "none",
};
export const Footer = () => {
  return (
    <Flex
      minH="100px"
      w="100%"
      mt="100px"
      px="100px"
      py="50px"
      justify="center"
      align="center"
      flexShrink={0}
      bg="linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)), #010D1F"
    >
      <Grid templateColumns={`repeat(${infos.length},1fr)`} templateRows="3fr 1fr" gap="8px">
        {infos.map((info, idx) => {
          let row = 1;
          if (idx < infos.length - 2) {
            row = 2;
          }
          return (
            <GridItem key={info.title} colSpan={1} rowSpan={row}>
              <Text fontSize="18px" color="white" mb="26px" {...noLinkStyle}>
                {info.title}
              </Text>
              {info.links.map((linkInfo) => {
                return (
                  <Flex
                    key={linkInfo.key}
                    align="center"
                    color="#D3D3D3"
                    display="block"
                    w="max-content"
                    mb="14px"
                  >
                    <Link
                      target="_blank"
                      href={linkInfo.link}
                      {...(linkInfo.link ? {} : noLinkStyle)}
                    >
                      {linkInfo.key}
                    </Link>
                    {linkInfo.qr_link && (
                      <Tooltip
                        placement="right-end"
                        label={<Image src={linkInfo.qr_link} w="150px" h="150px" />}
                      >
                        <chakra.span pos="relative">
                          <QrCodeIcon boxSize="16px" />
                        </chakra.span>
                      </Tooltip>
                    )}
                  </Flex>
                );
              })}
            </GridItem>
          );
        })}
        <GridItem colSpan={2} rowSpan={1} fontSize="14px">
          <Center h="100%">{copyright}</Center>
        </GridItem>
      </Grid>
    </Flex>
  );
};
